import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { appInsightsConfig } from '../env';
import { isFunctionalCookiesAllowed } from '../utils/cookies';

// We need to keep the same interface as the ApplicationInsights object to avoid errors
var appInsights = { trackEvent: () => {} };

if (isFunctionalCookiesAllowed()) {
  appInsights = new ApplicationInsights({
    config: appInsightsConfig,
  });

  const telemetryInitializer = (envelope) => {
    envelope.data.Tags = 'UI016';
  };

  appInsights.loadAppInsights();
  appInsights.addTelemetryInitializer(telemetryInitializer);
  appInsights.trackPageView();
}

export { appInsights };
